import * as React from 'react'

import moment from 'moment'

import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/DayPicker'
import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/Inputs/Select'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { dateBackendToUI, dateUIToBackend } from 'modules/core/lib/dates'
import { firstDayOfWeekAsIndex } from 'modules/core/lib/firstDayOfWeek'
import i18n from 'modules/core/lib/i18n'

import type ReportsForm from 'modules/employees/lib/forms/Reports'

type DateValues = [string | undefined, string | undefined]

export const DATERANGES = {
  current_month: 'current_month',
  current_year: 'current_year',
  custom: 'custom',
}
interface Props {
  form: ReportsForm
}

const DateRange = ({ form }: Props) => {
  const { access } = useCurrentSession()
  const minDate = React.useMemo(() => moment().subtract(1, 'years').startOf('year'), [])

  const startDate = form.get('from')
  const endDate = form.get('to')

  const firstDayOfWeek = firstDayOfWeekAsIndex(access.firstDayOfWeek)

  const onChangeEvent = (values: DateValues) => {
    const [startValue, endValue] = values

    const start = startValue ? dateBackendToUI(startValue) : undefined
    const end = endValue ? dateBackendToUI(endValue) : undefined

    startDate.set(start)
    endDate.set(end)
  }

  return (
    <>
      <FormRow>
        <Select
          label={i18n.t('employees.reports.daterange')}
          field={form.get('daterange')}
          options={[
            {
              value: DATERANGES.current_month,
              label: i18n.t('employees.reports.dateranges.current_month'),
            },
            {
              value: DATERANGES.current_year,
              label: i18n.t('employees.reports.dateranges.current_year'),
            },
            {
              value: DATERANGES.custom,
              label: i18n.t('employees.reports.dateranges.custom'),
            },
          ]}
        />
      </FormRow>

      {form.get('daterange').value === 'custom' && (
        <FormRow>
          <DayPicker
            mode="range"
            format={'ui_dmy_long'}
            label={i18n.t('time_off.date_range.label')}
            minDate={minDate}
            onChange={onChangeEvent}
            value={[
              startDate.value ? dateUIToBackend(startDate.value) : undefined,
              endDate.value ? dateUIToBackend(endDate.value) : undefined,
            ]}
            firstDayOfWeek={firstDayOfWeek}
            focusTrapActive={false}
          />
        </FormRow>
      )}
    </>
  )
}

export default observer(DateRange)
